import {
    FileConstructionNode,
    FileConstructionNodeInfo,
    FileConstructionPagination,
    FileConstructionState,
    FileDownloadLink,
    FileConstructionDigest,
    FileExtensionReg,
    DisplayTypeEnum,
    FileDownloadStatusTypeEnum,
} from '@/store/modules/fileConstruction/types';
import { Module, GetterTree, MutationTree, ActionTree, ActionContext } from 'vuex';
import {
    GetFileConstructionByUidReq,
    GetFileConstructionByPathReq,
    GetUserNameReq,
    NodeIdReq
} from '@/api/fileConstruction';
import { fileConstructionAPI } from '@/api/fileConstruction';
import { RootState } from '@/store/types';
import FileConstruction from "@/components/fileConstruction/FileConstruction.vue";

export const moduleName = "fileConstruction";

const statusCollectionUploaded = [
]

export enum FileConstructionGetters {
    GetUserName = "GET_USER_NAME",
    getIsUserNameLoading = "GET_IS_USERNAME_LOADING",
    getDiskSlice = "GET_DISK_SLICE",
    getCurrentFileConstructionNode = "GET_CURRENT_FILE_CONSTRUCTION_NODE",
    getCurrentPath = "GET_CURRENT_PATH",
    getInputPath = "GET_INPUT_PATH",
    getNodeByPathInStore = "GET_NODE_BY_PATH_IN_STORE",
    getNodeByPathInSearchStore = "GET_NODE_BY_PATH_IN_SEARCH_STORE",
    getLoading = "GET_LOADING",
    getBackHistoryAvailable = "GET_BACK_HISTORY_AVAILABLE",
    getForwardHistoryAvailable = "GET_FRONT_HISTORY_AVAILABLE",
    getBackHistory = "GET_BACK_HISTORY",
    getForwardHistory = "GET_FRONT_HISTORY",
    getIsSearching = "GET_IS_SEARCHING",
    getDownloadedFiles = "GET_DOWNLOADED_FILES",
    getCurrentDigest = "GET_CURRENT_DIGEST",
}

export enum FileConstructionMutations {
    setUserName = "SET_USER_NAME",
    setIsUserNameLoading = "SET_IS_USERNAME_LOADING",
    setDiskSlice = "SET_DISK_SLICE",
    setCurrentFileConstructionNode = "SET_CURRENT_FILE_CONSTRUCTION_NODE",
    setCurrentPath = "SET_CURRENT_PATH",
    setInputPath = "SET_INPUT_PATH",
    insertNodesToPath = "INSERT_NODES_IN_PATH",
    insertNodesToExtraPath = "INSERT_NODES_TO_EXTRA_PATH",
    setLoading = "SET_LOADING",
    resetAll = "RESET_ALL",
    setBackHistory = "SET_BACK_HISTORY",
    setForwardHistory = "SET_FORWARD_HISTORY",
    pushBackHistory = "PUSH_BACK_HISTORY",
    popBackHistory = "POP_BACK_HISTORY",
    cleanForwardHistory = "CLEAN_FORWARD_HISTORY",
    setCurrentNodePagination = "SET_CURRENT_NODE_PAGINATION",
    setDisplayType = "SET_DISPLAY_TYPE",
    setDownloadedFiles = "SET_DOWNLOADED_FILES",
    setNodeByPath = "SET_NODE_BY_PATH",
    setCurrentDigest = "SET_CURRENT_DIGEST",
}

export enum FileConstructionActions {
    asyncGetUserNameByProjIdAndUid = "ASYNC_GET_USER_NAME_BY_PROJ_ID_AND_UID",
    asyncGetChildrenByPath = "ASYNC_GET_CHILDREN_BY_PATH",
    asyncGetChildrenByPid = "ASYNC_GET_CHILDREN_BY_PID",
    asyncGenDownloadLink = "ASYNC_REQUEST_DOWNLOAD_LINK",
    asyncGetSearchResult = "ASYNC_GET_SEARCH_RESULT",
    asyncGetDownloadedFiles = "ASYNC_GET_DOWNLOADED_FILES",
    asyncGetUploadedFiles = "ASYNC_GET_UPLOADED_FILES",
    asyncGetExtensionFiles = "ASYNC_GET_EXTENSION_FILES",
    asyncGetDiskSlices = "ASYNC_GET_DISK_SLICES",
    goBack = "GO_BACK",
    goForward = "GO_FRONT",
}

export const DefaultPagination: FileConstructionPagination = {
    pageNum: 1,
    pageSize: 10,
}

const defaultFileConstructionNodeInfo: FileConstructionNodeInfo = {
    size: "",
    date_created: 0,
    date_modified: 0,
    date_accessed: 0,
}

const defaultNode: FileConstructionNode = {
    id: 0,
    parent_id: 0,
    isDummy: true,
    name: "root",
    isAllLoaded: false,
    info: defaultFileConstructionNodeInfo,
    pagination: DefaultPagination,
    children: [],
    file_type: 0,
    file_path: "",
    download_status: 0,
    download_link: { url: "", pwd: "" } as FileDownloadLink,
    full_path: "",
    ossLink: "",

}

const defaultSearchNode: FileConstructionNode = {
    id: 0,
    parent_id: 0,
    isDummy: true,
    name: "searchRoot",
    isAllLoaded: false,
    info: defaultFileConstructionNodeInfo,
    pagination: DefaultPagination,
    children: [],
    file_type: 0,
    file_path: "",
    download_status: 0,
    download_link: { url: "", pwd: "" } as FileDownloadLink,
    full_path: "",
    ossLink: "",
}

const defaultState: FileConstructionState = {
    userName: "",
    isUsernameLoading: false,
    diskSlice: [],
    currentPath: "",
    inputPath: "",
    currentNode: { ...defaultNode, children: [] },
    fileNodeTree: { ...defaultNode, children: [] },
    searchNodeTree: { ...defaultSearchNode, children: [] },
    isLoading: false,
    backHistory: [],
    forwardHistory: [],
    searchResult: [],
    isSearching: false,
    downLoadedFile: [],
    isDownloadedFileLoading: false,
    displayType: 0,
    currentDigest: undefined,
}

const state: FileConstructionState = { ...defaultState };

export const getters: GetterTree<FileConstructionState, RootState> = {
    [FileConstructionGetters.GetUserName](state): string {
        return state.userName;
    },
    [FileConstructionGetters.getIsUserNameLoading](state): boolean {
        return state.isUsernameLoading;
    },
    [FileConstructionGetters.getDiskSlice](state): FileConstructionNode[] {
        return state.diskSlice;
    },
    [FileConstructionGetters.getCurrentFileConstructionNode](state): FileConstructionNode {
        return state.currentNode;
    },
    [FileConstructionGetters.getCurrentPath](state): string {
        return state.currentPath;

    },
    [FileConstructionGetters.getInputPath](state): string {
        return state.inputPath;
    },
    [FileConstructionGetters.getCurrentDigest](state): FileConstructionDigest | undefined {
        return state.currentDigest;
    },
    [FileConstructionGetters.getNodeByPathInStore]: (state) =>
        (filePath: string): (FileConstructionNode | undefined) => {
            if (filePath === "") {
                return state.fileNodeTree;
            }
            const paths = filePath.split('/').filter((path: string) => path !== "");
            let cur: FileConstructionNode | undefined =
                state.displayType === DisplayTypeEnum.Searching || state.displayType === DisplayTypeEnum.Extension || state.displayType === DisplayTypeEnum.Uploaded || state.displayType === DisplayTypeEnum.Downloaded ?
                    state.searchNodeTree : state.fileNodeTree;
            paths.map((path: string) => {
                if (cur) {
                    cur = cur.children.find(child => child.name === path);
                } else {
                    return undefined;
                }

                if (!cur) {
                    return undefined;
                }
            })
            return cur;
        },
    [FileConstructionGetters.getLoading](state): boolean {
        return state.isLoading;
    },
    [FileConstructionGetters.getBackHistoryAvailable](state): boolean {
        return state.backHistory.length !== 0;
    },
    [FileConstructionGetters.getForwardHistoryAvailable](state): boolean {
        return state.forwardHistory.length !== 0;
    },
    [FileConstructionGetters.getBackHistory](state): string[] {
        return state.backHistory;
    },
    [FileConstructionGetters.getForwardHistory](state): string[] {
        return state.forwardHistory;
    },
    [FileConstructionGetters.getIsSearching](state): number {
        return state.displayType
    },
    [FileConstructionGetters.getDownloadedFiles](state): FileConstructionNode[] {
        return state.downLoadedFile;
    },

}

export const mutations: MutationTree<FileConstructionState> = {
    [FileConstructionMutations.setUserName](state, payload: string): void {
        state.userName = payload;
    },
    [FileConstructionMutations.setIsUserNameLoading](state, payload: boolean): void {
        state.isUsernameLoading = payload;
    },
    [FileConstructionMutations.setDiskSlice](state, payload: FileConstructionNode[]): void {
        state.diskSlice = payload;
    },
    [FileConstructionMutations.setCurrentFileConstructionNode](
        state,
        payload: FileConstructionNode,
    ): void {
        state.currentNode = payload;
    },
    [FileConstructionMutations.setCurrentPath](state, payload: string): void {
        if (payload.match(/的搜索结果/)) {
            state.displayType = 1
        } else if (payload === 'downloaded') {
            state.displayType = 2
        } else if (payload === 'uploaded') {
            state.displayType = 4
        } else if (payload.match(/的匹配结果/)) {
            state.displayType = 3
        } else {
            state.displayType = 0
            payload = payload.split('\\').join('/')
        }
        state.currentPath = payload;
        state.inputPath = payload;
    },
    [FileConstructionMutations.setInputPath](state, payload: string): void {
        state.inputPath = payload;
    },
    [FileConstructionMutations.insertNodesToPath](
        state,
        payload: {
            filePath: string,
            nodes: FileConstructionNode[],
        }): void {
        let cur: FileConstructionNode = state.fileNodeTree;
        if (payload.filePath !== "") {
            const paths = payload.filePath
                .split('/')
                .filter((path: string) => path !== "");
            // TODO
            // Implementing branch cut when first node not found
            paths.map((path: string) => {
                let tmpNode =
                    cur.children.find(child => child.name === path);
                if (!tmpNode) {
                    tmpNode = { ...defaultNode, children: [] };
                    tmpNode.name = path;
                    cur.children.push(tmpNode);
                }
                cur = tmpNode;
            });
        }
        const nodesToInsert = payload.nodes.filter((node: FileConstructionNode) => {
            const res = cur.children.find((x: FileConstructionNode) => x.name === node.name);
            return !res;
        });
        cur.children = cur.children.concat(nodesToInsert);
        cur.isDummy = false;
        state.currentNode = cur;

    },
    [FileConstructionMutations.insertNodesToExtraPath](state, payload: { filePath: string, nodes: FileConstructionNode[], isAppend: boolean }): void {
        let cur: FileConstructionNode = state.searchNodeTree

        let tmpNode = cur.children.find(child => child.name === payload.filePath);
        if (!tmpNode) {
            tmpNode = { ...defaultNode, children: [] };
            tmpNode.name = payload.filePath;
            cur.children.push(tmpNode);
        }
        cur = tmpNode;
        if (state.displayType === DisplayTypeEnum.Downloaded || state.displayType === DisplayTypeEnum.Uploaded || state.displayType === DisplayTypeEnum.Extension) {
            if (payload.isAppend === true) {
                cur.children = cur.children.concat(payload.nodes);
            } else {
                cur.children = payload.nodes
            }
        } else {
            cur.children = cur.children.concat(payload.nodes);
        }
        cur.isDummy = false;
        state.currentNode = cur;
    },
    [FileConstructionMutations.setLoading](state, payload: boolean): void {
        state.isLoading = payload;
    },
    [FileConstructionMutations.resetAll](state): void {
        Object.assign(state,
            {
                ...defaultState,
                currentNode: { ...defaultNode, children: [] },
                fileNodeTree: { ...defaultNode, children: [] },
                searchNodeTree: { ...defaultSearchNode, children: [] },
                backHistory: [],
                forwardHistory: [],
                searchResult: [],
                diskSlice: [],
                downLoadedFile: [],
                displayType: 0,
            }
        );
    },
    [FileConstructionMutations.setBackHistory](state, payload: string[]): void {
        state.backHistory = payload;
    },
    [FileConstructionMutations.setForwardHistory](stat, payload: string[]): void {
        state.forwardHistory = payload;
    },
    [FileConstructionMutations.pushBackHistory](state, payload: string): void {
        state.backHistory.push(payload);

    },
    [FileConstructionMutations.popBackHistory](state): void {
        state.backHistory.pop();
    },
    [FileConstructionMutations.cleanForwardHistory](state): void {
        state.forwardHistory = [];
    },
    [FileConstructionMutations.setCurrentNodePagination](state, payload: FileConstructionPagination): void {
        state.currentNode.pagination = payload;
    },
    [FileConstructionMutations.setDisplayType](state, payload: number): void {
        state.displayType = payload
    },
    [FileConstructionMutations.setDownloadedFiles](state, payload: FileConstructionNode[]): void {
        state.downLoadedFile = payload;
    },
    [FileConstructionMutations.setCurrentDigest](state, payload: FileConstructionDigest): void {
        state.currentDigest = payload;
    },
    [FileConstructionMutations.setNodeByPath](state, payload: { path: string, node: FileConstructionNode }): void {
        let cur: FileConstructionNode | undefined = state.fileNodeTree;
        if (payload.path !== "") {
            const paths = payload.path.split('/').filter((path: string) => path !== "");
            paths.map((path: string) => {
                if (cur) {
                    cur = cur.children.find(child => child.name === path);
                } else {
                    return undefined;
                }
            });
        }
        cur.id = payload.node.id
        cur.parent_id = payload.node.parent_id
    },
}

export const actions: ActionTree<FileConstructionState, RootState> = {
    async [FileConstructionActions.asyncGetUserNameByProjIdAndUid]({ commit }: ActionContext<FileConstructionState, RootState>, { projId, uid }: { projId: string, uid: string }): Promise<void> {
        try {
            commit(FileConstructionMutations.setIsUserNameLoading, true);
            const reqParams: GetUserNameReq = { projId: projId, uid: uid };
            const userName = await fileConstructionAPI.getUserNameByProjIdAndUid(reqParams);
            commit(FileConstructionMutations.setUserName, userName);
        } catch (err) {
            console.log(err);
        } finally {
            commit(FileConstructionMutations.setIsUserNameLoading, false);
        }
    },
    async [FileConstructionActions.asyncGetChildrenByPid]({ commit, getters }: ActionContext<FileConstructionState, RootState>, { projId, pid, uid, filePath }: { projId: string, pid: number, uid: string, filePath: string }): Promise<void> {
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        const curNodePagination = cachedNode ? cachedNode.pagination : { ...DefaultPagination };
        if (cachedNode && !cachedNode.isDummy && cachedNode.isAllLoaded) {
            try {
                const digest = await fileConstructionAPI.getDigestById({
                    projId: projId,
                    pid: pid,
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true);
                let targetPid = 0
                if (pid === 0 && filePath !== '') {
                    const nowNode = await fileConstructionAPI.getNodeByPath({
                        projId: projId,
                        path: filePath,
                        uid: uid,
                    });
                    commit(FileConstructionMutations.setNodeByPath, { path: filePath, node: nowNode });
                    targetPid = nowNode.id
                } else {
                    targetPid = pid
                }

                const reqParams: GetFileConstructionByUidReq = {
                    ...curNodePagination,
                    projId: projId,
                    pid: targetPid,
                    uid: uid,
                };
                commit(FileConstructionMutations.setCurrentDigest, undefined);
                const resp = await fileConstructionAPI.getChildrenByParentId(reqParams);
                const nodes = resp.nodes;

                commit(FileConstructionMutations.insertNodesToPath, { filePath: filePath, nodes });
                commit(FileConstructionMutations.setCurrentPath, filePath);
                commit(FileConstructionMutations.setCurrentDigest, resp.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
                newNode.pagination = { ...newNode.pagination, pageNum: newNode.pagination.pageNum + 1 };

                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);
            } catch (err) {
                console.log(err);
            } finally {
                commit(FileConstructionMutations.setLoading, false);
            }

        }

    },
    async [FileConstructionActions.asyncGetChildrenByPath]({ commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, filePath, uid, fileType }: { projId: string, filePath: string, uid: string, fileType: number }) {
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        if (cachedNode && !cachedNode.isDummy) {
            try {
                const digest = await fileConstructionAPI.getDigestById({
                    projId: projId,
                    pid: cachedNode.id,
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true);
                const filePathNew: string = filePath.replace(/\\/g, "/")
                const tmpFilePathSolution = filePathNew[filePathNew.length - 1] === "/" ?
                    filePathNew.slice(0, -1) : filePathNew;
                const searchNode = await fileConstructionAPI.getNodeByPath(
                    {
                        projId: projId,
                        path: tmpFilePathSolution,
                        uid: uid,
                    });
                const nodeFileType = searchNode.file_type

                const filePathSlice = tmpFilePathSolution.split('/')

                const currentPath = nodeFileType === 0 ?
                    filePathNew : filePathSlice.slice(0, filePathSlice.length - 1).join('/') + '/'

                const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](currentPath);
                const curNodePagination = cachedNode ? cachedNode.pagination : { ...DefaultPagination };
                // ====================
                const reqParams: GetFileConstructionByPathReq = {
                    ...curNodePagination,
                    projId: projId,
                    path: currentPath,
                    uid: uid,
                };
                commit(FileConstructionMutations.setCurrentDigest, undefined);
                const resp = await fileConstructionAPI.getChildrenByPath(reqParams);
                const nodes = resp.nodes;
                commit(FileConstructionMutations.setCurrentPath, currentPath);
                commit(FileConstructionMutations.insertNodesToPath, { filePath: currentPath, nodes: nodes });
                commit(FileConstructionMutations.setCurrentDigest, resp.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](currentPath);
                // Special Case in root node
                const currentNode = getters[FileConstructionGetters.getCurrentFileConstructionNode];
                const newNodeInfo = currentPath === "" ?
                    currentNode :
                    await fileConstructionAPI.getNodeByPath({ projId: projId, path: currentPath, uid: uid });

                newNode.id = newNodeInfo.id;
                newNode.parentid = newNodeInfo.parentid;
                newNode.info = newNodeInfo.info;
                newNode.pagination = { ...newNode.pagination, pageNum: newNode.pagination.pageNum + 1 };

                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);

            } catch (err) {
                console.log(err);
            } finally {
                commit(FileConstructionMutations.setLoading, false);
            }
        }
    },
    async [FileConstructionActions.asyncGenDownloadLink]({ commit, getters }: ActionContext<FileConstructionState, RootState>, { projId, nodeId, uid }: { projId: string, nodeId: number, uid: string }) {
        try {
            const reqParams: NodeIdReq = { projId: projId, uid: uid, nodeId: nodeId }
            await fileConstructionAPI.getMegaDownloadLink(reqParams)
        } catch (err) {
            console.log(err)
        }

    },
    [FileConstructionActions.goBack]({ commit, getters }: ActionContext<FileConstructionState, RootState>): string | undefined {
        const backHistory = getters[FileConstructionGetters.getBackHistory];
        const forwardHistory = getters[FileConstructionGetters.getForwardHistory];
        const currentPath = getters[FileConstructionGetters.getCurrentPath];
        const res = backHistory.pop();
        if (res || res === "") {
            forwardHistory.push(currentPath);
        }
        commit(FileConstructionMutations.setBackHistory, backHistory);
        commit(FileConstructionMutations.setForwardHistory, forwardHistory);
        commit(FileConstructionMutations.setCurrentPath, res);
        return res;
    },
    [FileConstructionActions.goForward]({ commit, getters }: ActionContext<FileConstructionState, RootState>): string | undefined {
        const backHistory = getters[FileConstructionGetters.getBackHistory];
        const forwardHistory = getters[FileConstructionGetters.getForwardHistory];
        const currentPath = getters[FileConstructionGetters.getCurrentPath];
        const res = forwardHistory.pop();
        if (res || res === "") {
            backHistory.push(currentPath);
        }
        commit(FileConstructionMutations.setBackHistory, backHistory);
        commit(FileConstructionMutations.setForwardHistory, forwardHistory);
        commit(FileConstructionMutations.setCurrentPath, res);
        return res;
    },

    async [FileConstructionActions.asyncGetSearchResult](
        { commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, uid, filename }: { projId: string, uid: string, filename: string }
    ): Promise<void> {
        const filePath = `${filename}的搜索结果`
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        const curNodePagination = cachedNode ? cachedNode.pagination : { ...DefaultPagination };

        if (cachedNode && !cachedNode.isDummy && cachedNode.isAllLoaded) {
            try {
                const digest = await fileConstructionAPI.getDigestByFuzzySearch({
                    projId: projId,
                    pathRegEx: filename,
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true)
                const res = await fileConstructionAPI.getSearchResult({
                    ...curNodePagination,
                    projId: projId,
                    fileName: filename,
                    uid: uid,
                });
                const nodes = res.nodes;
                commit(FileConstructionMutations.insertNodesToExtraPath, { filePath: filePath, nodes: nodes });
                commit(FileConstructionMutations.setCurrentPath, filePath);
                commit(FileConstructionMutations.setCurrentDigest, res.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath)
                newNode.pagination = { ...newNode.pagination, pageNum: newNode.pagination.pageNum + 1 };

                // newNode.children = nodes
                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);
            } catch (err) {
                console.log(err)
            } finally {
                commit(FileConstructionMutations.setLoading, false)
            }
        }

    },
    async [FileConstructionActions.asyncGetDownloadedFiles](
        { commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, uid, isAppend }: { projId: string, uid: string, isAppend: boolean }
    ): Promise<void> {
        const filePath = `downloaded`
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        const curNodePagination = cachedNode && isAppend ? cachedNode.pagination : { ...DefaultPagination };
        if (cachedNode && !isAppend) {
            cachedNode.isAllLoaded = false
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        }

        if (cachedNode && !cachedNode.isDummy && cachedNode.isAllLoaded) {
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
            try {
                const digest = await fileConstructionAPI.getDigestByFileStatus({
                    projId: projId,
                    status: FileDownloadStatusTypeEnum.DownloadedCollection,
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true)
                const res = await fileConstructionAPI.getFileListByDownloadStatus(
                    {
                        ...curNodePagination,
                        projId: projId,
                        uid: uid,
                        status:FileDownloadStatusTypeEnum.DownloadedCollection,
                    });
                const nodes = res.nodes;
                commit(
                    FileConstructionMutations.insertNodesToExtraPath,
                    { filePath: filePath, nodes: nodes, isAppend: isAppend }
                );
                commit(FileConstructionMutations.setCurrentPath, filePath);
                commit(FileConstructionMutations.setCurrentDigest, res.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath)
                newNode.pagination = { ...curNodePagination, pageNum: curNodePagination.pageNum + 1 };
                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);

            } catch (err) {
                console.log(err)
            } finally {
                commit(FileConstructionMutations.setLoading, false)
            }
        }
    },
    async [FileConstructionActions.asyncGetUploadedFiles](
        { commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, uid, isAppend }: { projId: string, uid: string, isAppend: boolean }
    ): Promise<void> {
        const filePath = `uploaded`
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        const curNodePagination = cachedNode && isAppend ? cachedNode.pagination : { ...DefaultPagination };
        if (cachedNode && !isAppend) {
            cachedNode.isAllLoaded = false
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        }

        if (cachedNode && !cachedNode.isDummy && cachedNode.isAllLoaded) {
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
            try {
                const digest = await fileConstructionAPI.getDigestByFileStatus({
                    projId: projId,
                    // status: [FileDownloadStatus.Uploaded],
                    status: FileDownloadStatusTypeEnum.UploadedCollection,
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true)
                const res = await fileConstructionAPI.getFileListByDownloadStatus(
                    {
                        ...curNodePagination,
                        projId: projId,
                        uid: uid,
                        // status: FileDownloadStatus.Uploaded,
                        status: FileDownloadStatusTypeEnum.UploadedCollection,
                    });
                const nodes = res.nodes;
                commit(
                    FileConstructionMutations.insertNodesToExtraPath,
                    { filePath: filePath, nodes: nodes, isAppend: isAppend },
                );
                commit(FileConstructionMutations.setCurrentPath, filePath);
                commit(FileConstructionMutations.setCurrentDigest, res.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath)
                newNode.pagination = { ...curNodePagination, pageNum: curNodePagination.pageNum + 1 };

                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);

            } catch (err) {
                console.log(err)
            } finally {
                commit(FileConstructionMutations.setLoading, false)
            }
        }
    },
    async [FileConstructionActions.asyncGetExtensionFiles](
        { commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, uid, extension, isAppend }: { projId: string, uid: string, extension: string, isAppend: boolean }
    ): Promise<void> {
        const filePath = `${extension}的匹配结果`
        const cachedNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath);
        const curNodePagination = cachedNode && isAppend ? cachedNode.pagination : { ...DefaultPagination };
        if (cachedNode && !isAppend) {
            cachedNode.isAllLoaded = false
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        }

        if (cachedNode && !cachedNode.isDummy && cachedNode.isAllLoaded) {
            try {
                const digest = await fileConstructionAPI.getDigestByExtension({
                    projId: projId,
                    extension: FileExtensionReg[extension as keyof typeof FileExtensionReg],
                    uid: uid,
                });
                commit(FileConstructionMutations.setCurrentDigest, digest);
            } catch (err) {
                console.log(err);
            }
            commit(FileConstructionMutations.setCurrentPath, filePath);
            commit(FileConstructionMutations.setCurrentFileConstructionNode, cachedNode);
        } else {
            try {
                commit(FileConstructionMutations.setLoading, true)
                const res = await fileConstructionAPI.getSearchResult(
                    {
                        ...curNodePagination,
                        projId: projId,
                        fileName: FileExtensionReg[extension as keyof typeof FileExtensionReg],
                        uid: uid,
                    }
                );
                const nodes = res.nodes;

                commit(FileConstructionMutations.insertNodesToExtraPath,
                    { filePath: filePath, nodes: nodes, isAppend: isAppend });
                commit(FileConstructionMutations.setCurrentPath, filePath);
                commit(FileConstructionMutations.setCurrentDigest, res.digest);
                const newNode = getters[FileConstructionGetters.getNodeByPathInStore](filePath)
                newNode.pagination = { ...newNode.pagination, pageNum: newNode.pagination.pageNum + 1 };

                // newNode.children = nodes
                if (!nodes || (nodes.length < newNode.pagination.pageSize)) {
                    newNode.isAllLoaded = true;
                }
                commit(FileConstructionMutations.setCurrentFileConstructionNode, newNode);
            } catch (err) {
                console.log(err)
            } finally {
                commit(FileConstructionMutations.setLoading, false)
            }
        }

    },

    async [FileConstructionActions.asyncGetDiskSlices](
        { commit, getters }: ActionContext<FileConstructionState, RootState>,
        { projId, uid }: { projId: string, uid: string }
    ): Promise<void> {
        try {
            commit(FileConstructionMutations.setLoading, true)

            const nodes = await fileConstructionAPI.getDiskByProjIdAndUid({ projId: projId, uid: uid });
            commit(FileConstructionMutations.setDiskSlice, nodes);
        } catch (err) {
            console.log(err)
        } finally {
            commit(FileConstructionMutations.setLoading, false)
        }

    },
}

export const fileConstruction: Module<FileConstructionState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
